import { useState } from "react";

export function ScheduleEditor({ list, onSave, onClose }) {
  const fmt = (ts) => ts ? new Date(ts).toISOString().slice(0, 10) : "";
  const [from, setFrom] = useState(fmt(list.activeFrom));
  const [to,   setTo]   = useState(fmt(list.activeTo));
  return (
    <div style={{ background: "var(--surface2)", borderRadius: 12, padding: ".85rem 1rem", margin: ".5rem 0", border: "1px solid var(--border)" }} onClick={e => e.stopPropagation()}>
      <div style={{ fontWeight: 700, fontSize: ".82rem", marginBottom: ".6rem" }}>📅 Schedule: {list.name}</div>
      <div style={{ display: "flex", gap: ".65rem", flexWrap: "wrap", alignItems: "flex-end" }}>
        <div>
          <div style={{ fontSize: ".72rem", color: "var(--muted)", fontWeight: 700, marginBottom: ".25rem" }}>Active from</div>
          <input type="date" className="wm-input" value={from} onChange={e => setFrom(e.target.value)} style={{ width: 150 }} />
        </div>
        <div>
          <div style={{ fontSize: ".72rem", color: "var(--muted)", fontWeight: 700, marginBottom: ".25rem" }}>Active until</div>
          <input type="date" className="wm-input" value={to} onChange={e => setTo(e.target.value)} style={{ width: 150 }} />
        </div>
        <button className="wm-btn" onClick={() => onSave(list.id, from, to)}>Save</button>
        <button className="wm-btn secondary" onClick={() => onSave(list.id, "", "")}>Clear</button>
        <button className="wm-btn secondary" onClick={onClose}>Cancel</button>
      </div>
      <div style={{ fontSize: ".72rem", color: "var(--muted)", marginTop: ".5rem" }}>Leave blank to have no date restriction. List must also be set to Active.</div>
    </div>
  );
}
